import { Component, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { AuthenticationResult } from '../models/authentication.model';
import { AuthenticationStatus } from '../enums/enums';
import { NgForm } from '../../../../node_modules/@angular/forms';
import { InvisibleReCaptchaComponent } from '../../../../node_modules/ngx-captcha';
import { ModalService } from 'hsg';
import { AuthUserService } from '../auth-user.service';

@Component({
  selector: 'app-auth-permanent-password',
  templateUrl: './auth-permanent-password.component.html',
  styleUrls: ['./auth-permanent-password.component.css']
})

export class AuthPermanentPasswordComponent extends AuthBaseComponent implements OnInit {

  public showCaptcha: boolean = false;
  public _countTimes: number = 0;
  private _form: NgForm;
  private _captchaResponse: string = null;
  private _captchaReady: boolean = false;

  @ViewChild('captchaElem') captchaElem: InvisibleReCaptchaComponent;
 
  constructor(private renderer: Renderer2, protected modalService: ModalService, protected authService: AuthUserService) {
    super(modalService, authService);
  }

  ngOnInit(): void {
    const element = this.renderer.selectRootElement('#pPassword');
    if(element){
      element.setAttribute('aria-invalid', true);
      setTimeout(() => element.focus(), 0);
    }
    this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2108' })
      .subscribe(res => console.log("sent elasticLog code:2108 - open window", res), error => console.log("sent elasticLog - open window error!", error));
    sessionStorage.setItem("currentWindow", "סיסמה קבועה");
    sessionStorage.setItem("elasticCode", "2188");
  }

  captchaSuccess(captchaResponse: string): void {
    this._captchaResponse = captchaResponse;
    this.callServer();
  }
  captchaReady() {
    this._captchaReady = true;
  }
  submit(form): void {
    this._form = form;

    const element = this.inputsQuery.map(elm => elm.elementRef.nativeElement).find(elm => elm.classList.contains('ng-invalid'));
    if (element) {
      element.setAttribute('aria-invalid', true);
      setTimeout(() => element.focus(), 0);
    }
    if (form.valid) {
      this.pending = true;
      this.serverError = null;
      if (this._captchaReady) {
        this.captchaElem.execute();
      }
      else {
        this.callServer();
      }
    }
    this.buildFormAccessibility();
  }

  private callServer() {
    this.authUserService.sendAuthData("ValidatePassword", { Password: this._form.value.pPassword, captchaResponse: this._captchaResponse })
      .subscribe((res: AuthenticationResult) => {
        if (res.Status == AuthenticationStatus.Failure && res.Details.UserInputError == "InvalidPassword") {
          this.serverError = "הסיסמה אינה תקינה";
          if (this.captchaElem != null && this.showCaptcha) {
            this.captchaElem.resetCaptcha();
          }
          if (this._countTimes == 8) {
            this.showCaptcha = true;
          }
          else {
            this._countTimes++;
          }
          const elements = this.inputsQuery.map(elm => elm.elementRef.nativeElement);
          if (elements && elements.length > 0) {
            elements[0].setAttribute('aria-invalid', true);
            setTimeout(() => elements[0].focus(), 0);
          }
        } else if (res.Details.UserInputError == "ReCaptchaInvalid") {
          this.captchaElem.resetCaptcha();
          this.serverError = "הקאפצ'ה נכשלה";
        }
        else {
          this.modalService.close(res.Details);
        }
      }, () => this.pending = false,
        () => this.pending = false
      )
  }
}
